"use client";
import {
  LinkIcon
} from "./chunk-7LH7ZARU.mjs";
import {
  link_default
} from "./chunk-FGDGYNYV.mjs";
import {
  useLink
} from "./chunk-NBGQML4S.mjs";
export {
  link_default as Link,
  LinkIcon,
  useLink
};
